import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Blog = () => {
  const navigate = useNavigate();

  const posts = [
    {
      title: '10 Tips for Maintaining a Clean Home',
      excerpt: 'Learn the best practices to keep your home spotless with minimal effort. Our expert tips will save you time and energy.',
      author: 'Sarah Johnson',
      date: 'Dec 10, 2024',
      category: 'Home Care',
      image: 'https://images.unsplash.com/photo-1758273705723-26ef454252ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBob21lJTIwY2xlYW5pbmclMjBzZXJ2aWNlJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc2NTgwNDMzNHww&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'The Benefits of Hiring a Professional Cook',
      excerpt: 'Discover how a professional home cook can transform your daily meals and save you valuable time.',
      author: 'Rahul Verma',
      date: 'Dec 8, 2024',
      category: 'Cooking',
      image: 'https://images.unsplash.com/photo-1659354217586-c5931b31e4c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBjb29rJTIwY2hlZiUyMGhvbWUlMjBzZXJ2aWNlfGVufDB8fHx8MTc2NTgwNDMzOXww&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'How to Choose the Right Home Service Provider',
      excerpt: 'A comprehensive guide to selecting trustworthy and reliable service providers for your home.',
      author: 'Priya Sharma',
      date: 'Dec 5, 2024',
      category: 'Tips & Guides',
      image: 'https://images.unsplash.com/photo-1758686254107-b381b6829be0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxob21lJTIwc2VydmljZSUyMGxpZmVzdHlsZXxlbnwwfHx8fDE3NjU4MDQzNDV8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'Car Cleaning 101: Essential Maintenance Tips',
      excerpt: 'Keep your vehicle looking brand new with these professional car cleaning and maintenance tips.',
      author: 'Amit Kumar',
      date: 'Dec 3, 2024',
      category: 'Car Care',
      image: 'https://images.unsplash.com/photo-1758273238370-3bc08e399620?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBob21lJTIwY2xlYW5pbmclMjBzZXJ2aWNlJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc2NTgwNDMzNHww&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'The Rise of On-Demand Home Services in India',
      excerpt: 'Exploring how technology is transforming the home services industry and making life easier for millions.',
      author: 'Vikram Singh',
      date: 'Dec 1, 2024',
      category: 'Industry Trends',
      image: 'https://images.unsplash.com/photo-1634403665481-74948d815f03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzbWFydHBob25lJTIwbW9ja3VwfGVufDB8fHx8MTc2NTczNTU5MHww&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'Creating a Cleaning Schedule That Works',
      excerpt: 'Practical strategies to maintain a clean and organized home without feeling overwhelmed.',
      author: 'Anita Desai',
      date: 'Nov 28, 2024',
      category: 'Home Organization',
      image: 'https://images.unsplash.com/photo-1758273705723-26ef454252ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBob21lJTIwY2xlYW5pbmclMjBzZXJ2aWNlJTIwbGlmZXN0eWxlfGVufDB8fHx8MTc2NTgwNDMzNHww&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center space-x-2 cursor-pointer" onClick={() => navigate('/')}>
              <img 
                src="https://customer-assets.emergentagent.com/job_ec527428-3aec-42a4-a1f7-d2e66c0be0df/artifacts/hktez0bk_logo_transs.png" 
                alt="doorush logo" 
                className="h-10 w-auto"
              />
            </div>
            <Button onClick={() => navigate('/')} variant="outline" className="border-2 border-[#007e7a] text-[#007e7a] hover:bg-[#007e7a] hover:text-white">
              Back to Home
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#007e7a]/5 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            doorush Blog
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Tips, guides, and insights about home services, cleaning, cooking, and more.
          </p>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post, index) => (
              <Card key={index} className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group">
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <Badge className="absolute top-4 left-4 bg-[#007e7a] text-white">
                    {post.category}
                  </Badge>
                </div>
                <CardHeader>
                  <CardTitle className="text-xl font-bold text-gray-900 line-clamp-2">
                    {post.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 mb-4 line-clamp-3">{post.excerpt}</p>
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                    <div className="flex items-center gap-1">
                      <User size={14} />
                      <span>{post.author}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Calendar size={14} />
                      <span>{post.date}</span>
                    </div>
                  </div>
                  <Button variant="outline" className="w-full group border-[#007e7a] text-[#007e7a] hover:bg-[#007e7a] hover:text-white">
                    Read More
                    <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={16} />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;